module.exports = __webpack_public_path__ + "static/media/aoe-triangle-2-with-black.ad30957e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/lib/monsters/aoe-triangle-2-with-black.svg
// module id = 62
// module chunks = 0